import React from "react";

function Avaya() {
    return(
        <h1>This si the avaya page</h1>
    );
}

export default Avaya